<div class="archived-compliances-container">
  <app-compliance-tasks
    [columns]="columns"
    [data]="complianceData"
    [isLoading]="isLoading"
    [isComplianceLibrary]="true"
    [isArchivedBtn]="true"
    (searchChanged)="onSearch($event)"
    (restoreClicked)="onRestoreClickAsync($event)"
    (scrolledDown)="onScrollDown()">
  </app-compliance-tasks>
</div>